import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const PaidIcon = _ref => {
  let {
    size,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 6 12",
    fill: "currentColor",
    width: size || '6',
    height: size || '12'
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.819 10.2l.036 1.8H2.376l.036-1.743C1.091 10.13.34 9.45 0 9.16l1.006-1.358c.363.326 1.151.834 2.133.834.691 0 1.03-.316 1.03-.736 0-.465-.387-.67-1.32-1.078l-.728-.318C.861 5.968.339 5.244.339 4.313c0-1.258.97-2.349 2.23-2.57L2.521 0H4l-.036 1.742c1.164.187 1.709.894 1.807 1.023L4.715 4.027a2.276 2.276 0 0 0-1.576-.632c-.63 0-.958.33-.958.76 0 .478.449.742 1.213 1.08l.594.26C5.37 6.1 6 6.7 6 7.806c0 1.048-.727 2.126-2.181 2.393",
    fillRule: "evenodd"
  }));
};
PaidIcon.displayName = 'PaidIcon';
export default PaidIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=PaidIcon.js.map